import React from 'react'
import { Card } from 'react-bootstrap'
import { FaInfoCircle } from 'react-icons/fa'
import {
  // StatsSection,
  SectionTitle,
  DetailCard,
  DetailHeader,
  DetailGrid,
  DetailItem,
  DetailLabel,
  DetailValue,
} from '../styles'

interface ProjectInformationPanelProps {
  projectId: string
  description: string
  annotationType: string
  totalItems: number
  updatedAt: string
}

const ProjectInformationPanel: React.FC<ProjectInformationPanelProps> = ({
  projectId,
  description,
  annotationType,
  totalItems,
  updatedAt,
}) => {
  return (
    <>
      <SectionTitle>
        <FaInfoCircle /> Project Information
      </SectionTitle>
      <DetailCard>
        <DetailHeader>
          <h3>Project Details</h3>
        </DetailHeader>
        <Card.Body>
          <DetailGrid>
            <DetailItem>
              <DetailLabel>Project ID</DetailLabel>
              <DetailValue>{projectId}</DetailValue>
            </DetailItem>
            <DetailItem>
              <DetailLabel>Description</DetailLabel>
              <DetailValue>{description || 'No description available'}</DetailValue>
            </DetailItem>
            <DetailItem>
              <DetailLabel>Annotation Type</DetailLabel>
              <DetailValue>{annotationType?.replace('_', ' ')}</DetailValue>
            </DetailItem>
            <DetailItem>
              <DetailLabel>Total Items</DetailLabel>
              <DetailValue>{totalItems}</DetailValue>
            </DetailItem>
            <DetailItem>
              <DetailLabel>Last Updated</DetailLabel>
              <DetailValue>{new Date(updatedAt).toLocaleString()}</DetailValue>
            </DetailItem>
          </DetailGrid>
        </Card.Body>
      </DetailCard>
    </>
  )
}

export default ProjectInformationPanel
